import React, {useContext, useEffect, useMemo} from "react";
import { withReact, Slate } from "slate-react";
import { createEditor } from "slate";
import { withHistory } from "slate-history";
import isUrl from "is-url";
import StaleEditor from "./StaleEditor";
import { wrapLink } from "./utils/linkWraps";
import StaleToolbar from "./StaleToolbar";
import {ActionIcon, Box, Image, Text} from "@mantine/core";
import { Icon } from "./StaleComponents";
import "./styles.css";
import { setMessage } from "../../../store/reducers/root";
import { useSelector, useDispatch } from "react-redux";
import {AppContext} from "../../../contexts/appContext";
import {useFiles} from "../../../hooks/useFiles";

const StaleComposer = ({ images, setImages, handleFileUpload }) => {
  const { filesContext } = useContext(AppContext);

  const editor = useMemo(
    () => withInlines(withHistory(withReact(createEditor()))),
    [],
  );

  const filesArray = useFiles()
  const dispatch = useDispatch();
  const message = useSelector((state) => state.message);

  const removeImage = (index) => {
    const newImages = [...images];
    newImages.splice(index, 1);
    setImages(newImages);
  };

  return (
    <div className={"parent-focused"}>
      <Slate
        editor={editor}
        initialValue={message !== "" ? message : initialValue}
        onChange={() => dispatch(setMessage(editor.children))}
      >
        <StaleEditor />
        {images.length > 0 && (
          <Box display={"flex"} w={"100%"} mt={"10px"}>
            {images.map((file, index) => {
              return (
                <Box key={`${index}-image`} className="image-container">
                  <Image
                    className={"image"}
                    src={URL.createObjectURL(file[0])}
                    alt="uploaded image"
                    fit="contain"
                    width={75}
                    height={75}
                    // style = {{margin: "5px"}}
                  />
                  <ActionIcon
                    className={"remove-button"}
                    onClick={() => removeImage(index)}
                    variant="dark"
                    color="gray.9"
                    size="sm"
                    radius={"xl"}
                  >
                    <Icon>close</Icon>
                  </ActionIcon>
                </Box>
              );
            })}
          </Box>
        )}
        <StaleToolbar setImages={setImages} images={images} handleFileUpload={handleFileUpload} />
        {filesArray.length > 0 && (
          <Box className={"file-parent"} >
            {filesArray.map((file, index) => {
              return (
                <Box key={`${index}-file`} className="file-container">
                  <Box display={"flex"}>
                    <Icon>attach_files</Icon>
                    <Text fz={"xs"} truncate>{file.name}</Text>
                  </Box>
                  <ActionIcon
                    className={"remove-button"}
                    onClick={() => {
                      filesContext.removeFile(index)
                      handleFileUpload();
                    }}
                    variant="dark"
                    color="gray.9"
                    size="sm"
                    radius={"xl"}
                  >
                    <Icon>close</Icon>
                  </ActionIcon>
                </Box>
              );
            })}
          </Box>
        )}
      </Slate>
    </div>
  );
};

const initialValue = [
  {
    type: "paragraph",
    children: [{ text: "" }],
  },
];

const withInlines = (editor) => {
  const { insertData, insertText, isInline } = editor;

  editor.isInline = (element) =>
    ["link"].includes(element.type) || isInline(element);

  editor.insertText = (text) => {
    if (text && isUrl(text)) {
      wrapLink(editor, text);
    } else {
      insertText(text);
    }
  };

  editor.insertData = (data) => {
    const text = data.getData("text/plain");
    if (text && isUrl(text)) {
      wrapLink(editor, text);
    } else {
      insertData(data);
    }
  };

  return editor;
};

export default StaleComposer;
